/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

/**
 * The upstream prototype releases this port matches, as the About dialogs
 * show them: the display version on the version line, and the absorbed
 * upstream commit as that line's hover. Change both here when absorbing an
 * upstream commit. The export package's `generator.version` is stamped
 * separately (core/constants.js `APP_VERSION`).
 */
export interface UpstreamVersion {
  /** The version the upstream About dialog shows. */
  displayVersion: string
  /** The upstream repository and the commit absorbed. */
  source: string
}

/** Medaica Viewer (pcg-viewer-mvp). */
export const VIEWER_UPSTREAM_VERSION: UpstreamVersion = {
  displayVersion: "0.9.1.0",
  source: "pcg-viewer-mvp 20ac6e4",
}

/** Medaica Report (cardiac-panel-v4). */
export const REPORT_UPSTREAM_VERSION: UpstreamVersion = {
  displayVersion: "0.6.1",
  source: "cardiac-panel-v4 eba1cd1",
}
